export function Logo({ size = 36, withWordmark = true, dark = false, className = '' }) {
  const ink = dark ? '#FAFAF7' : '#1B2A4E';
  const lime = '#C8E847';
  const paper = dark ? '#1B2A4E' : '#FAFAF7';

  if (!withWordmark) {
    return (
      <div className={`logo-iso ${className}`} style={{ width: size, height: size, padding: size * 0.18, gap: size * 0.06 }}>
        <span style={{ display: 'block', height: size * 0.05, width: size * 0.55, background: lime, borderRadius: 0 }} />
        <span style={{ display: 'block', height: size * 0.04, width: size * 0.55, background: paper, borderRadius: 0 }} />
        <span style={{ display: 'block', height: size * 0.04, width: size * 0.55, background: paper, borderRadius: 0 }} />
        <span style={{ display: 'block', height: size * 0.05, width: size * 0.36, background: lime, borderRadius: 0 }} />
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="logo-iso" style={{ width: size, height: size, padding: size * 0.18, gap: size * 0.06 }}>
        <span style={{ display: 'block', height: size * 0.05, width: size * 0.55, background: lime }} />
        <span style={{ display: 'block', height: size * 0.04, width: size * 0.55, background: paper }} />
        <span style={{ display: 'block', height: size * 0.04, width: size * 0.55, background: paper }} />
        <span style={{ display: 'block', height: size * 0.05, width: size * 0.36, background: lime }} />
      </div>
      <div className="leading-none">
        <div style={{ color: ink, fontWeight: 700, fontSize: size * 0.5, letterSpacing: '-0.025em' }}>LibroContable</div>
        <div className="font-mono uppercase mt-1" style={{ fontSize: size * 0.18, letterSpacing: '0.18em', color: dark ? 'rgba(250,250,247,0.7)' : '#6B7280' }}>SLC S.A.S</div>
      </div>
    </div>
  );
}
